import { useContext } from 'react';
import {
  AuthContext,
  FirestoreWritePermissionContext,
  SESSION_STORAGE_KEYS,
  useSessionStorage,
} from '@monash/portal-frontend-common';
import { SnackbarDispatcher } from '../SnackbarDispatcher';
import c from '../popup.module.scss';
import { Dropdown, Switch } from '@monash/portal-react';
import classNames from 'classnames';

const Misc = () => {
  const { user } = useContext(AuthContext);
  const hasWriteRole = user?.roles?.includes('studentportal-custompage-admin');

  const { checkWritePerms, hasWritePerms, updateWritePerms } = useContext(
    FirestoreWritePermissionContext
  );

  const showWritePermsToggle = checkWritePerms && hasWriteRole;

  const [altBE, setAltBE] = useSessionStorage('alt-backend');
  const altServices = ['tinky-winky', 'dipsy', 'laa-laa', 'po'].map((x, i) => {
    return { id: i, text: x, value: x };
  });

  const [forceCodeError, setForceCodeError] = useSessionStorage(
    'forceCodeError',
    false
  );

  const [showGlobalBanner, setShowGlobalBanner] = useSessionStorage(
    'mock:showGlobalBanner'
  );

  const [numberOfBanners, setNumberOfBanners] = useSessionStorage(
    'mock:numberOfGlobalBanners',
    'One'
  );

  const [showPageBanners, setShowPageBanners] = useSessionStorage(
    SESSION_STORAGE_KEYS.MOCKS.SHOW_PAGE_BANNERS
  );

  const [showEncumbrances, setShowEncumbrances] = useSessionStorage(
    'mock:showEncumbrances'
  );

  const wrapperClasses = classNames(c.stack, c.tabWrapper);

  return (
    <div className={wrapperClasses}>
      {showWritePermsToggle && (
        <>
          <div>
            <div className={c.label}>
              Enable firestore writes while impersonating
            </div>
            <Switch
              on={hasWritePerms}
              onClick={() => {
                updateWritePerms(!hasWritePerms);
              }}
            />
          </div>

          <hr />
        </>
      )}

      {import.meta.env.VITE_ENV === 'local' && (
        <>
          <hr />

          <div>
            <div className={c.label}>Use alt backend</div>

            <Dropdown
              id="type"
              className="custom-class"
              ariaLabelledby="type"
              onChange={(value) => {
                setAltBE(value);
              }}
              value={altBE}
              data={[
                { id: 'default', text: 'default', value: null },
                ...altServices,
              ]}
              shouldPortal={false}
            />
          </div>
        </>
      )}

      <hr />

      <div>
        <div className={c.label}>Force code error</div>
        <Switch
          on={forceCodeError}
          onClick={() => {
            setForceCodeError(!forceCodeError);
          }}
        />
      </div>

      <hr />

      <div>
        <div className={c.label}>Show global banner</div>
        <Switch
          on={showGlobalBanner}
          onClick={() => {
            setShowGlobalBanner(!showGlobalBanner);
          }}
        />

        <Dropdown
          id="type"
          className="custom-class"
          ariaLabelledby="type"
          onChange={(value) => {
            setNumberOfBanners(value);
          }}
          value={numberOfBanners}
          data={['One', 'Many'].map((x, i) => {
            return { id: i, text: x, value: x };
          })}
        />
      </div>

      <hr />

      <div>
        <div className={c.label}>Show page banners</div>
        <Switch
          on={showPageBanners}
          onClick={() => {
            setShowPageBanners(!showPageBanners);
          }}
        />
      </div>

      <hr />

      <div>
        <div className={c.label}>Show encumbrances</div>
        <Switch
          on={showEncumbrances}
          onClick={() => {
            setShowEncumbrances(!showEncumbrances);
          }}
        />
      </div>

      <hr />

      <div className={c.inputWrapper}>
        <div className={c.label}>Snackbar</div>
        <SnackbarDispatcher />
      </div>
    </div>
  );
};

export default Misc;
